<template>
  <div :id="time">
    <div style="text-align: center; padding-left: 30% !important" width="100%">
      <v-alert
        v-if="responseStatus.alertStatus"
        :type="responseStatus.type"
        width="40%"
        style="z-index: 9999; text-align: left"
        dense
        dismissible
      >
        {{ responseStatus.text }}
      </v-alert>
    </div>
    <v-card>
      <v-card-title>{{ name }}</v-card-title>
      <v-card-text>
        <vue-editor
          v-model="detail"
          label="รายละเอียด"
          :editorToolbar="customToolbar"
        ></vue-editor>
        <!--div v-html="detail" style="margin-top:5px;"></div-->
      </v-card-text>
      <v-card-actions class="d-flex align-center justify-center">
        <!--v-btn color="secondary" @click="reset">Reset</!--v-btn-->

        <v-btn color="primary" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import axios from "axios";
import { VueEditor } from "vue2-editor";
export default {
  name: "Contents",
  // props: {
  //   name: {
  //     type: String,
  //   },
  //   code: {
  //     type: String,
  //   },
  // },
  components: {
    "vue-editor": VueEditor,
  },
  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      // name: this.$route.name,
      //detail: "รายละเอียด",
      time: new Date().toTimeString(),
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
      payload: "",
      watchCode: "",
      contents: {},
      detail: "",
      responseStatus: {
        alertStatus: false,
      },
    };
  },
  computed: {
    name() {
      console.log("code");
      this.getContents();
      this.$forceUpdate();
      return this.$route.name;
    },
    code() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.$route.meta.code;
    },
    // detail() {
    //   //return this.$route.name;
    //   return this.contents.detail;
    // },
  },

  beforeMount() {
    console.log("beforeCreate");
    //this.getContents();

    console.log(this.$route);
    //this.detail = this.name;
  },
  mounted() {
    console.log(this.code);
    //this.getContents();
    //this.$forceUpdate();
  },
  methods: {
    closeInTime(sec) {
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },
    //get content
    async getContents() {
      //let detail = "";
      //const url = process.env.VUE_APP_LOYALTY_API_URI;

      try {
        let payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
        };
        return await axios
          .get(
            this.api_uri + "/v1/contents/code/" + this.code,
            { params: payload } // need to change
          )
          .then((response) => {
            console.log(response);
            this.contents = response.data.data;
            this.detail = this.contents.detail;
            //this.watchCode = this.contents.code;
          });
      } catch (err) {
        console.log(err);
        this.contents = {};
      }
      //this.contents = detail;
    },
    reset() {
      //this.contents = this.contents;
    },
    async save() {
      //let uri = "/v1/contents/create";
      this.payload = {};
      if (this.contents._id === undefined) {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
          code: this.code,
          detail: this.detail,
          name: this.name,
          status: "Active",
        };
        console.log(this.payload);
        await axios
          .post(
            this.api_uri + "/v1/contents/create",
            this.payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            //console.log(response.data)
            //this.Product = response.data;
            this.contents = response.data.data;
            console.log(this.contents);
            this.responseStatus = {
              status: "Success",
              code: 0,
              color: "green",
              type: "success",
              text: "บันทึกสำเร็จ",
              alertStatus: true,
              data: response.data.data,
            };
            //console.log(this.responseStatus)
            //this.Product = response.data;
            //this.resetInput();
          });
      } else {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
          id: this.contents._id,
          code: this.code,
          detail: this.detail,
          name: this.name,
          status: "Active",
        };
        console.log(this.payload);
        await axios
          .put(
            this.api_uri + "/v1/contents/update",
            this.payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            console.log(response.data);
            if (response.data.status == 0) {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data.data,
              };
            }
            //console.log(this.responseStatus)
            //this.Product = response.data;
            //this.resetInput();
          });
      }
    },
  },
  watch: {
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          this.closeInTime(this.closeInSec);
        }
      },
    },
  },
};
</script>
